


























import IButton from '@/interfaces/IButton';
import { computed, defineComponent, ref } from '@vue/composition-api';
import InputGroup from './InputGroup.vue';
import Popover, { PopoverProps } from './Popover.vue';
export default defineComponent({
  components: {
    Popover,
    InputGroup
  },
  emits: ['confirmedDeletion'],
  props: {
    ...PopoverProps
  },
  setup(_, { root, emit }) {
    //  Refs
    const show = ref(false);
    const action = ref('');
    const title = ref('');
    const message = ref('');
    const primaryButton = ref(null as IButton | null);
    var primaryClick: (() => void) | null = null;
    var secondaryClick: (() => void) | null = null;

    function confirmAction(
      mAction: string,
      mTitle: string,
      mMessage: string,
      mPrimaryButton?: IButton | null
    ): Promise<boolean> {
      show.value = true;
      action.value = mAction;
      title.value = mTitle;
      message.value = mMessage;
      if (mPrimaryButton) primaryButton.value = mPrimaryButton;

      return new Promise(function (resolve, _) {
        primaryClick = () => {
          resolve(true);
          show.value = false;
        };

        secondaryClick = () => {
          resolve(false);
          show.value = false;
        };
      });
    }

    return {
      show,
      confirmAction,
      action,
      title,
      message,
      primaryButton: computed<IButton>(() => {
        return primaryButton.value
          ? {
              title: root.$tc(primaryButton.value.i18n ?? ''),
              variant: primaryButton.value.variant,
              onClick: () => {
                if (primaryClick != null) primaryClick();
              }
            }
          : {
              title: root.$tc('common.delete'),
              variant: 'danger',
              onClick: () => {
                if (primaryClick != null) primaryClick();
              }
            };
      }),
      secondaryButton: computed<IButton>(() => {
        return {
          title: root.$tc('common.cancel'),
          variant: 'outline-info',
          onClick: () => {
            if (secondaryClick != null) secondaryClick();
          }
        };
      })
    };
  }
});
